<template>
  <v-dialog v-model="dialog" width="600" persistent>
    <v-card style="border-radius: 10px">
      <v-card-title class="d-flex justify-space-between align-center">
        <span class="text-h6">Basic Info</span>
        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />

      <v-card-text>
        <v-form ref="formRef">
          <v-text-field
            label="Email Id"
            placeholder="felixotieno899@gmail.com"
            v-model="email"
          />
          <small class="text-grey">
            This won't affect your login credentials for suuq
          </small>

          <v-text-field
            label="Phone No."
            class="mt-4"
            v-model="phoneNumber"
          />
          <small class="text-grey">
            This won't affect your login credentials for suuq
          </small>

          <v-select
            label="Gender *"
            :items="['Male', 'Female', 'Prefer not to say']"
            class="mt-4"
            v-model="gender"
          />
          <v-text-field
            label="Date of Birth"
            type="date"
            v-model="dob"
          />

          <v-select
            label="Language *"
            :items="['English', 'Somali']"
            v-model="language"
          />
          <v-text-field
            label="Nationality"
            v-model="nationality"
          />
          <v-select
            label="Visa Status *"
            :items="[
              'Not Applicable',
              'Business',
              'Employment',
              'Residence',
              'Spouse',
              'Student',
              'Tourist',
              'Visit',
            ]"
            v-model="visaStatus"
          />
          <v-text-field
            label="Country"
            v-model="country"
          />
          <v-select
            label="Career Level *"
            :items="[
              'Student/Intern',
              'Junior',
              'Mid-level',
              'Senior',
              'Manager',
              'Executive Director',
            ]"
            v-model="careerLevel"
          />
          <v-select
            label="Desired Salary (per month)"
            :items="[
              'Negotiable',
              'Less than 2,000',
              '2,000 - 3,999',
              '4,000 - 5,999',
              '6,000 - 7,999',
              '8,000 - 11,999',
              '12,000 - 19,999',
              '20,000 +',
            ]"
            v-model="salaryExpectation"
          />
        </v-form>
      </v-card-text>

      <v-card-actions class="px-4 pb-4">
        <div class="flex justify-space-between">
          <v-btn variant="outlined" class="text-grey mr-3" @click="clearFields"
            >Clear All</v-btn
          >

          <v-btn color="primary" variant="flat" @click="save">Save</v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { ref, watch, defineProps, defineEmits } from "vue";
import { useStore } from "vuex";

const store = useStore();

const props = defineProps({
  modelValue: Boolean,
});
const emit = defineEmits(["update:modelValue"]);

// Each field is a local ref:
const email = ref("");
const phoneNumber = ref("");
const gender = ref("");
const dob = ref("");
const language = ref("");
const nationality = ref("");
const visaStatus = ref("");
const country = ref("");
const careerLevel = ref("");
const salaryExpectation = ref("");

// Mirror the parent v-model:
const dialog = ref(props.modelValue);

// Keep local dialog in sync with parent
watch(
  () => props.modelValue,
  (val) => {
    dialog.value = val;
  }
);

// Whenever local dialog changes, emit to parent
watch(dialog, (val) => {
  emit("update:modelValue", val);
});

// When the dialog opens, pull any existing values from the store
watch(
  () => dialog.value,
  (isOpen) => {
    if (isOpen) {
      const info = store.state.profile.basicInfo || {};
      email.value = info.email || "";
      phoneNumber.value = info.phoneNumber || "";
      gender.value = info.gender || "";
      dob.value = info.dob || "";
      language.value = info.language || "";
      nationality.value = info.nationality || "";
      visaStatus.value = info.visaStatus || "";
      country.value = info.country || "";
      careerLevel.value = info.careerLevel || "";
      salaryExpectation.value = info.salaryExpectation || "";
    }
  }
);

// Clear all fields
function clearFields() {
  email.value = "";
  phoneNumber.value = "";
  gender.value = "";
  dob.value = "";
  language.value = "";
  nationality.value = "";
  visaStatus.value = "";
  country.value = "";
  careerLevel.value = "";
  salaryExpectation.value = "";
}

// Save and dispatch to Vuex
const save = () => {
  store.dispatch("profile/saveBasicInfo", {
    email: email.value,
    phoneNumber: phoneNumber.value,
    gender: gender.value,
    dob: dob.value,
    language: language.value,
    nationality: nationality.value,
    visaStatus: visaStatus.value,
    country: country.value,
    careerLevel: careerLevel.value,
    salaryExpectation: salaryExpectation.value,
  });

  // Log to verify
  console.log("🟢 [profile.basicInfo] =", store.state.profile.basicInfo);

  // Close dialog
  dialog.value = false;

  // (Optional) dispatch an alert:
  store.dispatch("alert/success", "Basic info saved successfully");
};
</script>

<style scoped>
/* (any scoped styles you already had) */
</style>
